export default "<video class=\"video-player-wrapper\" src=\"{{ videoPath }}\" controls>\n"